import { DriverReservationsApi } from "components/Apis/driverReservationsAPI";
import { CRUDRow } from "components/Briefing/helpers";
import Actions from "components/Briefing/subcomponents/actions";
import HistoryViewer from "components/Briefing/subcomponents/historyViewer";
import BriefingTable from "components/Briefing/subcomponents/table";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { TextField } from "./subcomponents/fields";

const ReservationsTable = () => {
    const [content, setContent] = useState([]);

    const briefing = useSelector((state) => state.briefing.line);
    const startDate = useSelector((state) => state.archiveSearch.startDate);
    const endDate = useSelector((state) => state.archiveSearch.endDate);
    const searchTerm = useSelector((state) => state.archiveSearch.searchTerm);

    const requestPayload = {
        "startDate": startDate,
        "endDate": endDate,
        "searchTerm": searchTerm
    }

    const DataURL = "admin/driver_reservations/get_reservations";
    const RowURL = "admin/driver_reservations/reservations";

    const fetchRows = async () => {
        if (briefing === "Old Briefings") {
            const response = await DriverReservationsApi.getArchived(requestPayload);
            setContent(response.data);
        }
        else if (briefing === "Briefings") {
            const response = await DriverReservationsApi.getActive();
            setContent(response.data);
        }
    }

    useEffect(() => {
        (async () => {
            fetchRows()
        })();
    }, [briefing, startDate, endDate, searchTerm]);

    // Function to create a new row and refresh the table
    const RowOpp = async (action = "create", rowID = null) => {
        await CRUDRow(RowURL, action, rowID);
        // Re-fetch data after modifying the rowe
        await fetchRows();
    };

    const updateExpiry = async (id, value) => {
        try {
            const response = await DriverReservationsApi.update(id, {
                expiry: value || null
            });
            toast.success("Expiration Date Updated");
        }
        catch (error) {
            if (error.response.data.msg) {
                toast.error(error.response.data.msg);
            }
            else {
                toast.error("Update Failed");
            }
        }
    }

    const headers = [
        "ID",
        "Driver Name(s)",
        "Pro/Bus #",
        "Notes",
        "Expiration",
        "Act."
    ];

    const renderRow = (row) => (
        <tr key={row.id}>
            <td className="row-id-cell">
                <div className="row-id-div">
                    {row.id}
                </div>
            </td>
            <td style={{ width: "15%" }}>
                <TextField field={row.name} maxLength={100} />
            </td>
            <td style={{ width: "15%" }}>
                <TextField field={row.pro} maxLength={25} />
            </td>
            <td style={{ width: "60%" }}>
                <TextField field={row.note} maxLength={250} />
            </td>
            <td>
                <input
                    type="datetime-local"
                    className="input"
                    defaultValue={row.expiry}
                    onBlur={(e) => {updateExpiry(row.id, e.target.value)}}
                    disabled={row.archived.value}
                />
            </td>
            <td className="actions-cell">
                <Actions
                    onDelete={() => RowOpp("delete", row.id)} // Wrap in a function
                    onArchive={() => RowOpp("archive", row.id)} // Wrap in a function
                />
            </td>
        </tr>
    );

    if (briefing === "Old Briefings" && !content.length) {
        return null
    }

    return (
        <>
            <div className="table-header">
                <h2>
                    Driver Reservations
                </h2>
                <HistoryViewer
                    url={DataURL}
                />
            </div>
            <BriefingTable
                headers={headers}
                rows={content}
                renderRow={renderRow}
                createRow={RowOpp}
            />
        </>
    );
};

export default ReservationsTable;
